import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Customer, Invoice } from '@thro-types/billing';

interface Props {
  open: boolean;
  customer: (Customer & { invoice?: Invoice; isCensored?: boolean }) | undefined;
}

export const customerDrawerInitialState: Props = {
  open: false,
  customer: undefined
};

const customerDrawerSlice = createSlice({
  name: 'customerDrawer',
  initialState: customerDrawerInitialState,
  reducers: {
    close(state) {
      state.open = false;
      state.customer = undefined;
    },
    open(state) {
      state.open = true;
    },
    setCustomer(
      state,
      action: PayloadAction<(Customer & { invoice?: Invoice; shouldHide?: boolean }) | undefined>
    ) {
      state.customer = action.payload;
    }
  }
});

export const {
  actions: CustomerDrawerActions,
  reducer: CustomerDrawerReducer,
  name: CustomerDrawerSliceKey
} = customerDrawerSlice;
